<template>
  <v-app style="background-color: #DAD0CE">
    <SecMenuHeader></SecMenuHeader>

    <v-main>
          <router-view></router-view>
    </v-main>

<!--
    <v-bottom-navigation height="50">
      <v-layout align-center justify-center>
        <span style="padding-left:50px" class="font-weight-medium"> copyright 2019 @ SKGroup</span>
       {{version}}
      </v-layout>
    </v-bottom-navigation>
-->    
  </v-app>
</template>

<script>
/* eslint-disable */
import SecMenuHeader from './components/MenuHeader/SecMenuHeader';
import Login from './components/Login/Login'
import {getUsername} from '@/assets/js/common.js'
import {authen} from '@/api/authen-api.js'

export default {
  name: 'App',
  components: {
    SecMenuHeader,
    Login
  },
  data: () => ({
       version: process.env.VUE_APP_VERSION
  }),
  methods : {
    checkAutherize() {
      let key = localStorage.getItem("key");
      this.isAutherize = (key && key !== '' && 0 !== key.length);
      if (this.isAutherize) {
        //this.currUser = getUser(key);
      }
    },
    onLoginSuccess(userName, result) {
        this.isAutherize = result;
        this.currUser = userName;
    }
  },
  beforeMount() {
      authen();
  },
};
</script>
